module.exports = __webpack_public_path__ + "assets/img/pj_w_app.675d1e3e.png";